import { useRateParameters } from '@/api/models/requests/hooks/useRateParameters'
import { AppModal } from '@/components/shared/modal'
import { MODAL_TITLE_ERROR } from '@/utils/constants'

import { AddRatingForm } from './AddRatingForm'
import { MODAL_TITLE_ADD_RATING } from './model/constants'
import { RequestRatingHeader } from './RequestRatingHeader'
import { ModalName } from './types/types'

type Props = {
  id: string
  isButtonUnsolvedAvailable: boolean
  visible: boolean
  onClose: () => void
  setModalName: (_: ModalName) => void
  refetchRequest: () => void
}

const AddRatingModal = ({
  id,
  isButtonUnsolvedAvailable,
  visible,
  onClose,
  setModalName,
  refetchRequest
}: Props) => {
  const {
    data: rateParameters,
    isLoading: areRateParametersLoading,
    isError: isRateParametersError,
    error: rateParametersError
  } = useRateParameters()

  return (
    <AppModal
      header={
        <RequestRatingHeader
          title={
            isRateParametersError ? MODAL_TITLE_ERROR : MODAL_TITLE_ADD_RATING
          }
        />
      }
      opened={visible}
      onClose={onClose}
    >
      <AddRatingForm
        id={id}
        isButtonUnsolvedAvailable={isButtonUnsolvedAvailable}
        onClose={onClose}
        setModalName={setModalName}
        refetchRequest={refetchRequest}
        rateParameters={rateParameters}
        areRateParametersLoading={areRateParametersLoading}
        isRateParametersError={isRateParametersError}
        rateParametersError={rateParametersError}
      />
    </AppModal>
  )
}

export { AddRatingModal }
